import supabase from '../supabase/supabase';

const TABLE = 'guest_house_content_1700000000000';
const BUCKET = 'guest-house-images-1700000000000';

export async function loadContent() {
  const { data, error } = await supabase.from(TABLE).select('content_key,payload');
  if (error) throw error;
  return Object.fromEntries((data || []).map(({ content_key, payload }) => [content_key, payload]));
}

export async function saveContent(key, payload) {
  const { error } = await supabase.from(TABLE).upsert({
    content_key: key,
    payload,
    updated_at: new Date().toISOString()
  }, { onConflict: 'content_key' });
  if (error) throw error;
}

export async function uploadImage(file) {
  if (!file.type.startsWith('image/') || file.size > 10 * 1024 * 1024) {
    throw new Error('Choose an image smaller than 10 MB.');
  }
  const extension = file.name.split('.').pop()?.toLowerCase() || 'jpg';
  const path = `${crypto.randomUUID()}.${extension}`;
  const { error } = await supabase.storage.from(BUCKET).upload(path, file, {
    cacheControl: '3600',
    contentType: file.type
  });
  if (error) throw error;
  return supabase.storage.from(BUCKET).getPublicUrl(path).data.publicUrl;
}